import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const AnythingService = {
    encript: async () => {
        let params = {
            plainText: "We are in Montreal",
        };

        const result = await ApiService.getData(`/test/encrypt`, params);
        Logger.log(result);
        return result;
    },

    createFrenchVersionsForGrid: async () => {
        try {
            const result = await ApiService.putData("/v1/puzzle/grid-tpl/create-french-versions-for-ready-to-review");
            return result;
        } catch (error) {
            Logger.error("Error creating French versions for grid puzzles:", error);
            throw error;
        }
    },

    createFrenchVersionsForCrossword: async () => {
        try {
            const result = await ApiService.putData("/v1/puzzle/cross-tpl/create-french-versions-for-ready-to-review");
            return result;
        } catch (error) {
            Logger.error("Error creating French versions for crossword puzzles:", error);
            throw error;
        }
    },

    placeWordsOnWordSearch: async (tplId) => {
        try {
            const result = await ApiService.putData(`/test/wordsearch/place-words/${tplId}`, {});
            return result;
        } catch (error) {
            Logger.error("Error placing words on word search puzzle:", error);
            throw error;
        }
    },

    /** Backfill word_of_the_day from startDate (ISO local date, Montreal). */
    batchWordOfTheDay: async (startDate) => {
        try {
            const qs = new URLSearchParams({ startDate: String(startDate).trim() });
            const result = await ApiService.putData(`/test/word-of-day/batch?${qs.toString()}`, {});
            return result;
        } catch (error) {
            Logger.error("Error batching word of the day:", error);
            throw error;
        }
    },

    /**
     * Strip non-topic findable words on PUBLISHED classic WORD_SEARCH 12×12 templates
     * (state unchanged), letter-fill empties, and delete all word-search play records.
     */
    migrateClassicWordSearchTopicWords: async () => {
        try {
            return await ApiService.putData("/test/wordsearch/migrate-classic-topic-words", {});
        } catch (error) {
            Logger.error("Error migrating classic word-search topic words:", error);
            throw error;
        }
    },
};

export default AnythingService;
